import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/table/table-cell.component.js'

const tagName = 'dap-ds-table-cell'

/**
 * Table cell component.
 * @element dap-ds-table-cell
 * @title - Table cell
 * @group table
 *
 * @slot - The default slot.
 *
 * @csspart base - The main cell container.
 *
 * @cssproperty --dds-table-cell-padding-block - Padding for the top and bottom of the cell. Default: var(--dds-spacing-200)
 * @cssproperty --dds-table-cell-padding-inline-start - Padding for the start (left in LTR) of the cell. Default: var(--dds-spacing-500)
 * @cssproperty --dds-table-cell-padding-inline-end - Padding for the end (right in LTR) of the cell. Default: var(--dds-spacing-500)
 * @cssproperty --dds-table-cell-border-width - Width of the cell's bottom border. Default: var(--dds-border-width-base)
 * @cssproperty --dds-table-cell-border-color - Color of the cell's bottom border. Default: var(--dds-border-neutral-subtle)
 * @cssproperty --dds-table-cell-text-color - Text color of the cell. Default: var(--dds-text-neutral-base)
 * @cssproperty --dds-table-cell-line-height - Line height of the cell text. Default: 1.5
 * @cssproperty --dds-table-cell-text-align - Text alignment in the cell. Default: left
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSTableCell',
})

export default reactWrapper
